import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const ROSIE_PURPLE = '#B082E4';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: ROSIE_PURPLE,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
      position: 'relative',
    }}>
<Paper elevation={0} sx={{ p: 4, width: '100%', maxWidth: 480, backgroundColor: '#fff', border: 'none' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box
            component="img"
            src="/nhs-logo.png"
            alt="Cambridge University Hospitals NHS Foundation Trust"
            sx={{ height: 60 }}
          />
        </Box>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Room Booking Service
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          Sign in to manage room bookings
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3, backgroundColor: ROSIE_PURPLE, '&:hover': { backgroundColor: '#8B5CC8' } }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <Divider sx={{ my: 3 }}>
          <Typography variant="body2" color="text.secondary">
            or
          </Typography>
        </Divider>

        <Button
          fullWidth
          variant="outlined"
          size="large"
          startIcon={<CalendarMonth />}
          onClick={() => navigate('/public-calendar')}
          sx={{ borderColor: ROSIE_PURPLE, color: ROSIE_PURPLE, '&:hover': { borderColor: '#8B5CC8', color: '#8B5CC8' } }}
        >
          View Calendar (Read Only)
        </Button>

      </Paper>
    </Box>
  );
}

export default Login;
